<template>
  <div :class="classes">
    <slot name="default" />
  </div>
</template>

<script>

export default {
  props: {
    altOrder: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    classes (){
      return {
        'button-set': true,
        'alt-order': this.altOrder
      }
    }
  }
}

</script>

<style scoped lang="scss">

.button-set {
  display: flex;
  
  &::v-deep .button {
    margin-top: 20px;
    width: 100%;
  }
}

@media (min-width: 600px) {
  .button-set.alt-order {
    flex-direction: row-reverse;
  }

  .button-set::v-deep .button {
    width: 40%;
    flex-grow: 1;
    margin: 20px 10px 0 10px;
  }

  .button-set::v-deep .button:nth-child(odd) {
    margin-left: 0;
  }

  .button-set.alt-order::v-deep .button:nth-child(odd) {
    margin-left: 10px;
    margin-right: 0;
  }

  .button-set::v-deep .button:last-child:nth-child(odd) {
    margin-left: 0;
    margin-right: 0;
  }

  .button-set::v-deep .button:nth-child(even) {
    margin-right: 0;
  }

  .button-set.alt-order::v-deep .button:nth-child(even) {
    margin-left: 0;
    margin-right: 10px;
  }
}

</style>